import React, { type ElementConfig } from 'react';
import { components } from 'react-select3';
import Tag from 'seedling/components/tag';
import LoadingSpinner from 'seedling/components/loading_spinner';
import { XIcon } from 'seedling/icons';
import { colors } from 'seedling/constants';

import {
  TieredDropdown,
  VirtualizedDropdown,
} from 'seedling/components/dropdown_resources/legacy_select';

// $FlowFixMe
import ReactSelect from 'react-select3';
import CreatableSelect from 'react-select3/creatable';
import AsyncCreatableSelect from 'react-select3/async-creatable';

// $FlowFixMe
import ReactSelectAsync from 'react-select3/async';
import styled from 'styled-components';
import _ from 'underscore';

export const MultiValueLabel = styled(Tag)`
  padding-right: 25px;
  margin-top: 0;
  margin-bottom: 0;
  padding-top: 2px;
  padding-bottom: 2px;

  :first-of-type {
    margin-left: 0;
  }
`;

export const DropdownIndicator = (
  props: ElementConfig<typeof components.DropdownIndicator>
) => {
  return (
    <components.DropdownIndicator {...props}>
      <DropdownArrow menuIsOpen={props.selectProps.menuIsOpen} />
    </components.DropdownIndicator>
  );
};

export const LoadingIndicator = (
  props: ElementConfig<typeof components.LoadingIndicator>
) => {
  return <LoadingSpinner {...props} size={'small'} />;
};

const StyledXIcon = styled(XIcon)`
  margin-top: 2px;
`;

export const XIndicator = () => <StyledXIcon size={14} />;

export const ClearIndicator = (
  props: ElementConfig<typeof components.ClearIndicator>
) => (
  <components.ClearIndicator {...props}>
    {XIndicator()}
  </components.ClearIndicator>
);

export const DropdownArrow = styled.div`
  border-color: #666666 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
  position: relative;
  top: 2px;

  ${props =>
    props.menuIsOpen &&
    `
    top: 0px;
    border-color: transparent transparent ${colors.darkGrey};
    border-width: 0 5px 5px;
  `}
`;

// **************
// Wrap with Styled component for some custom things
// **************
const StyledDropdownWrapper = component => {
  return styled(component)`
    // -- custom rule to indent options nested under group --
    .sl-dropdown__group .sl-dropdown__option {
      padding-left: 40px;
    }

    // -- prevent multiline options from overflowing and blocking subsequent ones --
    .sl-dropdown__option {
      height: auto;
    }
  `;
};

export const StyledReactSelect = StyledDropdownWrapper(ReactSelect);
export const StyledReactSelectAsync = StyledDropdownWrapper(ReactSelectAsync);
export const StyledCreatableSelect = StyledDropdownWrapper(CreatableSelect);
export const StyledCreatableSelectAsync = StyledDropdownWrapper(
  AsyncCreatableSelect
);

export const getComponent = props => {
  if (props.isTiered) {
    return TieredDropdown;
  }

  if (props.isVirtualized) {
    return VirtualizedDropdown;
  }

  if (props.isLazyLoad) {
    return props.isCreatable ? StyledCreatableSelect : StyledReactSelect;
  }

  if (_.isFunction(props.options)) {
    return props.isCreatable
      ? StyledCreatableSelectAsync
      : StyledReactSelectAsync;
  }

  return props.isCreatable ? StyledCreatableSelect : StyledReactSelect;
};
